import React, {Fragment} from 'react';
import {Box, Divider, Grid, Typography} from '@material-ui/core';
import FieldText from './text/FieldText';
import Select from './select/Select';
import Check from './check/Check';

function Inputs() {
    return (
        <Fragment>
            <Typography variant='subtitle1' gutterBottom>
                {'Inputs'}
            </Typography>
            <Divider variant='middle' />
            <form noValidate>
                <Grid container spacing={4} justifyContent={'space-between'}>
                    <Grid item xs={6}>
                        <FieldText />
                    </Grid>
                    <Grid container item xs={6} direction='column'>
                        <Grid item>
                            <Select />
                        </Grid>
                        <Grid item>
                            <Box pt={4}>
                                <Check />
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </Fragment>
    );
}

export default Inputs;
